import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import startCase from 'lodash/startCase';

// Local Deps
import './SearchBadge.scss';

/*
* This value dictates the number of displayed items
* for value property that is an array.
* Must be a minimum of 2.
*/
// const SEARCH_BADGE_DISPLAY_MAX = 2;

export default class SearchBadge extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    text: PropTypes.string,
  };

  static defaultProps = {
    name: '',
    value: '',
    text: '',
  };

  static _formatValuesArray(valuesArray) {
    const titleCasedValues = valuesArray.map(val => startCase(val));
    let formattedValues;

formattedValues = (
    <Fragment>
    {titleCasedValues}
  </Fragment>
    );
/*
    // Handle display max if number of values execeeds the max:
    if (titleCasedValues.length > SEARCH_BADGE_DISPLAY_MAX) {
      // Slice displayed values
      const slicedValues = titleCasedValues.slice(0, SEARCH_BADGE_DISPLAY_MAX);
      const reaminingValueCount =
        titleCasedValues.length - SEARCH_BADGE_DISPLAY_MAX;

      // This array will automatically be processed as text by jsx
      formattedValues = (
        <Fragment>
          {slicedValues.join(', ')},
          <span className="nf-search-badge__more-text">
            {' '}
            + {reaminingValueCount} more...
          </span>
        </Fragment>
      );

      return formattedValues;
    }
*/
    // Format return text
    formattedValues = titleCasedValues.join(', ');
    return formattedValues;
  }

  render() {
    const { name, value, text } = this.props;
    /* 
    * If a user passes in a "text" prop,
    * exit early and just show that text in the badge.
    */
    if (text) {
      return (
        <Badge className="nf-search-badge" color="none">
          {text}
        </Badge>
      );
    }  
    const formattedValue = Array.isArray(value) ? SearchBadge._formatValuesArray(value) : value;
    const formattedName = startCase(name);
    let colorStyle = {};
    let {materials, methods, minQty,minEstCost } = '';
      if ( name === 'materials' ){
        materials = `${formattedName}: ${formattedValue.length>0?formattedValue:"NO BID MATCHING SELECTED FOR MATERIALS!"}`;
        if(formattedValue.length === 0){colorStyle={color:'red'}}
      } else if (name === 'methods'){        
        methods = `${formattedName}: ${formattedValue.length>0?formattedValue:"NO BID MATCHING SELECTED FOR METHODS!"}`;       
        if(formattedValue.length === 0){colorStyle={color:'red'}}
      } else if (name === 'minQuantity'){        
        minQty = `${formattedName}: ${formattedValue}`;        
      } else if (name === 'minEstimatedCost'){       
        minEstCost = `${formattedName}: ${formattedValue}`;        
      }
    return (
      <div>
        <span className="badge nf-search-badge nf-search-badge__name" style={colorStyle}>{materials}</span>   
        <span className="badge nf-search-badge nf-search-badge__name" style={colorStyle}>{methods}</span>       
        <span className="badge nf-search-badge nf-search-badge__name" >{minQty}</span>       
        <span className="badge nf-search-badge nf-search-badge__name" >{minEstCost}</span>  
      </div>
     );
   }
 }



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/SearchBadge/SearchBadge.jsx